import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ReactJoyride, { EVENTS, ACTIONS } from 'react-joyride'
import i18next from 'i18next'

import { showInfo } from 'store/entities/toastr/utils'
import TourTooltip from './TourTooltip'
import { TAB_LEADER_BOARD, TAB_RECENT } from 'app/constants/feed'

class Tour extends Component {
  static propTypes = {
    stepIndex: PropTypes.number.isRequired,
    steps: ImmutablePropTypes.listOf(ImmutablePropTypes.map.isRequired).isRequired,
    run: PropTypes.bool.isRequired,
    setRun: PropTypes.func.isRequired,
    setQueries: PropTypes.func.isRequired,
    setStepIndex: PropTypes.func.isRequired,
  }

  simulateClickOnElementById = idElement => {
    const ev = new CustomEvent('click', { bubbles: true })
    const el = document.getElementById(idElement)
    el.dispatchEvent(ev)
    el.scrollIntoView()
  }

  handleJoyrideCallback = data => {
    const { index, type, action, size } = data

    // check for element exists in DOM
    const target = data.step.target.slice(1)
    const isTargetExists = document.getElementById(target) || document.getElementsByClassName(target)[0]
    const isLastStep = size - 1 === index

    if (
      [EVENTS.STEP_BEFORE, EVENTS.TOUR_START, EVENTS.TARGET_NOT_FOUND].includes(type) &&
      !isTargetExists &&
      !isLastStep
    ) {
      this.props.setStepIndex(index + 1)
    }
    if ([EVENTS.STEP_BEFORE, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if (index === 4) {
        this.simulateClickOnElementById(TAB_LEADER_BOARD)
      }
      if (index === 5) {
        this.simulateClickOnElementById(TAB_RECENT)
      }
    } else if (action === ACTIONS.STOP) {
      // Need to set our running state to false, so we can restart if we click start again.
      this.props.setRun(false)
      showInfo({
        content: i18next.t(
          'user:You will receive your first MicroAction tomorrow or you can start today from this dashboard!'
        ),
      })
      this.props.setQueries({ isReadyToRunTour: false })
    }
  }

  render() {
    const { run, steps, stepIndex } = this.props
    return (
      <ReactJoyride
        steps={steps.toJS()}
        continuous
        callback={this.handleJoyrideCallback}
        disableOverlayClose
        stepIndex={stepIndex}
        tooltipComponent={TourTooltip}
        run={run}
        scrollToFirstStep
        scrollOffset={100}
      />
    )
  }
}

export default Tour
